import { useMemo } from "react";
import type { DiscoverItem } from "../types";
import { useDiscoverContext, useDiscoverItems } from "../state/discover-context";

export function useSelectedItem(): DiscoverItem | null {
  const { state } = useDiscoverContext();
  const items = useDiscoverItems();
  return useMemo(() => {
    if (state.selectedItemId === null) return null;
    return items.find((item) => item.id === state.selectedItemId) ?? null;
  }, [items, state.selectedItemId]);
}
